// @ts-check

import React from "react"
import { MultiStateCheckbox as PrimeMultiStateCheckbox } from "primereact/multistatecheckbox"

/**
 * @param {import("./MultiStateCheckbox.atom").MultiStateCheckboxProps} props
 * @returns {JSX.Element}
 */
export function MultiStateCheckbox(props) {
  const DEFAULT_OPTIONS = [
    {
      value: "all",
      icon: "pi pi-check",
    },
    {
      value: "partial",
      icon: "pi pi-minus",
    },
  ]

  const {
    options = DEFAULT_OPTIONS,
    optionValue = "value",
    value,
    onChange,
    className = "",
  } = props

  return (
    <PrimeMultiStateCheckbox
      options={options}
      optionValue={optionValue}
      value={value}
      onChange={onChange}
      className={className}
    />
  )
}
